Customer.Ticket ||= {}

class Customer.Ticket.AuthorView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/header/author"]

  initialize: (@options = {}) ->
    @model = @options.model

  render: ->
    @$el.html(@template(
      participants: @_getParticipants(),
      sub_type: @_getSubType(),
      id: @_getId(),
      title: @_getTitle()
    ))
    @

  _getParticipants: ->
    if @model
      participants = @model.get('dialogue').participants
      if participants.length < 6
        return participants.join(', ')
      else
        return participants.slice(0, 5).join(', ') + ' and others'
    return ''

  _getSubType: ->
    return @model.get('sub_type') if @model
    return 'email'

  _getId: ->
    return @model.get('id') if @model
    return ''

  _getTitle: ->
    return "#{I18n.t('customer.dashboard.conversations.details.type_indicators.email')}:" unless @model
    return @_twitterTitle() if @model.get('type') == 'twitter'
    return @_facebookTitle() if @model.get('type') == 'facebook'
    return "#{I18n.t('customer.dashboard.conversations.details.type_indicators.email')}:" if @_getSubType() == 'email'
    "#{I18n.t('customer.dashboard.conversations.details.webchat')}:"

  _twitterTitle: ->
    if @_getSubType() == 'tweet'
      "#{I18n.t('customer.dashboard.conversations.details.twitter_conversation')}:"
    else
      "#{I18n.t('customer.dashboard.conversations.details.twitter_dm')}:"

  _facebookTitle: ->
    if @_getSubType() == 'fb-message'
      "#{I18n.t('customer.dashboard.conversations.details.facebook_pm')}:"
    else
      "#{I18n.t('customer.dashboard.conversations.details.facebook_post')}:"
